import { PLYLoader } from 'three/examples/jsm/loaders/PLYLoader';

const loader = new PLYLoader();

export const loadPly = (buffer) => {
  const geometry = loader.parse(buffer);

  if (!geometry.getAttribute('normal')) {
    geometry.computeVertexNormals();
  }

  return geometry;
};
